const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M2.25 7.5A3.75 3.75 0 0 1 6 3.75h12a3.75 3.75 0 0 1 3.75 3.75v9A3.75 3.75 0 0 1 18 20.25H6a3.75 3.75 0 0 1-3.75-3.75zM6 5.25A2.25 2.25 0 0 0 3.75 7.5v9A2.25 2.25 0 0 0 6 18.75h5.25V5.25zm12 13.5h-5.25v-6h7.5v3.75A2.25 2.25 0 0 1 18 18.75m2.25-7.5h-7.5v-6H18a2.25 2.25 0 0 1 2.25 2.25z" clip-rule="evenodd"/></svg>';
export {
  e as w
};
